import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import withTooltips from 'flight/mixins/with-tooltips';

export default defineComponent(OnlineIndicator, withTooltips);

function OnlineIndicator() {
    this.attributes({
        indicatorSelector: null,
        statusEvent: 'uiUpdateUserStatus',
    });

    this.after('initialize', function() {
        $(document).on(this.attr.statusEvent, this.updateStatus.bind(this));
    });

    this.updateStatus = function(e, data) {
        if (data.action == 'online') {
            this.appearOnline(data.id);
        } else {
            this.appearOffline(data.id);
        }
    };

    this.appearOnline = function(userId) {
        this.findIndicators(userId).attr('data-online', '');
    };

    this.appearOffline = function(userId) {
        this.findIndicators(userId).removeAttr('data-online');
    };

    this.findIndicators = function(userId) {
        return this.$node.find('[' + this.attr.indicatorSelector + '=' + userId + ']');
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/ui/online-indicator.js